/**
 * @prettier
 */

/**
 * Defining form validation rules
 *
 * @type object
 */
const ocrVerification = {
    ocrFirstName: {
        name: 'idpal_first_name',
        id: 'firstName',
        required: true,
        min: 1,
        max: 50,
        regex: "^[\\p{Script=Han}\\p{Script=Latin} ,.'’\\-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_error',
        },
    },
    ocrLastName: {
        name: 'idpal_last_name',
        id: 'lastName',
        required: true,
        min: 1,
        max: 50,
        regex: "^[\\p{Script=Han}\\p{Script=Latin} ,.'’\\-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_error',
        },
    },
    ocrDob: {
        name: 'idpal_dob',
        type: 'date',
        minDate: '1900-01-01',
        maxDate: '',
        id: 'dob',
        required: true,
    },
    ocrPhone: {
        name: 'idpal_phone',
        type: 'phone',
        required: true,
    },
    ocrAddress1: {
        name: 'idpal_address_1',
        id: 'address1',
        required: true,
        min: 1,
        max: 50,
        regex: "^[\\p{Script=Han}\\p{Script=Latin}0-9 ,.'’\\-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_numbers_error',
        },
    },
    ocrAddress2: {
        name: 'idpal_address_2',
        id: 'address2',
        required: false,
        min: 1,
        max: 50,
        regex: "^[\\p{Script=Han}\\p{Script=Latin}0-9 ,.'’\\-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_numbers_error',
        },
    },
    ocrCity: {
        name: 'idpal_city',
        id: 'city',
        required: true,
        min: 1,
        max: 50,
        regex: "^[\\p{Script=Han}\\p{Script=Latin}0-9 ,.'’\\-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_numbers_error',
        },
    },
    ocrCounty: {
        name: 'idpal_county',
        id: 'county',
        required: true,
        min: 1,
        max: 50,
        regex: "^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'’-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_numbers_error',
        },
    },
    ocrPostCode: {
        name: 'idpal_postcode',
        id: 'postCode',
        required: true,
        min: 1,
        max: 25,
        regex: "^[\\p{Script=Han}\\p{Script=Latin}0-9 ,.'’\\-]+$",
        messages: {
            regex: 'idpal_allowed_characters_letters_numbers_error',
        },
    },
    ocrCountry: {
        name: 'idpal_country',
        id: 'country',
        placeholder: 'Select',
        required: true,
        optionValue: 'iso_3166_3',
        optionName: 'name',
    },
    ocrEmail: {
        name: 'idpal_email',
        id: 'email',
        required: true,
        min: 5,
        max: 254,
        regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
        messages: {
            regex: 'idpal_invalid_email_format',
        },
    },
};

export { ocrVerification };
